import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot } from '@angular/router';

import { SharedService } from './shared/shared.service';
import { TranslatedNotificationService } from './shared/translation/translated-notification.service';

import { UserRole } from './shared/model';
import { map } from 'rxjs/operators';

@Injectable()
export class CanActivateUserRole implements CanActivate {
  constructor(private sharedService: SharedService,
    private notificationService: TranslatedNotificationService) {
  }

  canActivate(route: ActivatedRouteSnapshot) {
    return this.sharedService.getPermissionsLevel().pipe(
      map((userRole: UserRole) => {
        const requiredrole = route.data['role'] as UserRole || UserRole.User;
        if (userRole >= requiredrole) {
          return true;
        } else {
          this.notificationService.showMsgError('error.no_permission', 'You do not have permission to view this page');
          return false;
        }
      }));
  }
}
